import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    lessonsLoaded: false,
    loadingSingleLesson: false,
    lessons: [],
    lessonsView: '',
    lessonsSearch: '',
    lessonsSearchResult: [],
    lessonsSearchLoading: false,
    lessonsFilter: '',
    lessonMeta: {},
    lessonsNamesLoaded: false,
    lessonsNames: [],
    lessonsTrackerNames: [],
    lessonFolderModal: {
      value: false,
      lessons: [],
      folder: null,
      type: '',
    },

    itemMetrics: {},
    lessonMetrics: {},
    lessonMetricsFilter: {
      start_time: null,
      end_time: null,
    },

    ingestedItems: {}, // Map of item ID to ingestion status { ingested: Boolean | null, supported: Boolean | null }
  },

  mutations,
  actions,
  getters,
};
